module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("出版单位从业人员总体情况")]), _vm._v(" "), _c('p', [_vm._v("\n            出版单位职工总数："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.workers))]), _vm._v(" 人\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            音像制品从业人员总数："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.businessworkersyx))]), _vm._v(" 人\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            电子出版物从业人员总数："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.businessworkersdz))]), _vm._v("\n            人\n          ")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "233px"
    },
    attrs: {
      "id": "base_chart"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("人员构成")]), _vm._v(" "), _c('p', [_vm._v("\n            领导班子：音像\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.businessleaderyx))]), _vm._v(" 人，电子\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.businessleaderdz))]), _vm._v(" 人\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            编辑人员：音像 "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.totalworkeryx))]), _vm._v(" 人，电子\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.totalworkerdz))]), _vm._v(" 人\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            制作加工人员： 音像\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.pepnumprocessyx))]), _vm._v(" 人， 电子\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.pepnumprocessdz))]), _vm._v(" 人\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            新媒体、网络运营等技术人员：音像\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.pepnuminternationyx))]), _vm._v(" 人，电子\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.pepnuminternationdz))]), _vm._v(" 人\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            专职出版物发行人员：音像\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.pepnumissueyx))]), _vm._v(" 人，电子\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.pepnumissuedz))]), _vm._v(" 人\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            其他人员：音像\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.pepnumotheryx))]), _vm._v(" 人，电子\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.pepnumotherdz))]), _vm._v(" 人\n          ")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "358.4px"
    },
    attrs: {
      "id": "member_chart"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "274px"
    },
    attrs: {
      "id": "member_pie_media"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "274px"
    },
    attrs: {
      "id": "member_pie_electr"
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c507bd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChartWorker/WorkerBase.vue
// module id = 1780
// module chunks = 1